function adjustSwiperHeight() {
  const swiper = document.querySelector(".swiper");
  if (!swiper) return;

  const activeSlideImg = swiper.querySelector(".swiper-slide-active img");

  if (activeSlideImg) {
    const imgHeight = activeSlideImg.getBoundingClientRect().height;
    swiper.style.height = `${imgHeight}px`;
  }
}

// 初期表示
window.addEventListener("load", adjustSwiperHeight);

// リサイズ対応
window.addEventListener("resize", adjustSwiperHeight);

// Swiper のスライド切替時にも更新
const swiperInstance = new Swiper(".swiper", {
  on: {
    slideChange: adjustSwiperHeight,
  },
});

var swiper = new Swiper(".swiper", {
    direction: 'vertical',
    slidesPerView: 1,
    spaceBetween: 0,
    autoHeight: false,
    mousewheel: {
    forceToAxis: true,
    thresholdDelta: 40,
    thresholdTime: 400 
  },
  simulateTouch: true,
  resistanceRatio: 0.85, 
    loop: false,
    observer: true,
    observeParents: true,
    pagination: {
    el: ".swiper-pagination",
    type: "bullets",
    clickable: true,
    }
  });